import { render, staticRenderFns } from "./ProjectSessionDetailsModal.vue?vue&type=template&id=0ab2ca58&scoped=true&"
import script from "./ProjectSessionDetailsModal.vue?vue&type=script&lang=js&"
export * from "./ProjectSessionDetailsModal.vue?vue&type=script&lang=js&"
import style0 from "./ProjectSessionDetailsModal.vue?vue&type=style&index=0&id=0ab2ca58&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ab2ca58",
  null
  
)

export default component.exports